export default __webpack_public_path__ + "static/media/shoppage-package4.ed863e7d.svg";